import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/annadirPedido`, method: 'POST', body: values, token: token})
}
